import { Component, OnInit, OnDestroy, AfterContentInit, ChangeDetectionStrategy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLinkActive } from '@angular/router';
import { UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../auth.service';
import { BehaviorSubject, Subscription, timer } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { DataShareService } from '../../../services/data-share.service';
import localforage from 'localforage';
import { Location, NgOptimizedImage, NgClass, AsyncPipe } from '@angular/common'
import { ToastrService } from 'ngx-toastr';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatFormField } from '@angular/material/form-field';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatInput } from '@angular/material/input';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';



@Component({
    selector: 'app-answer-challenge',
    templateUrl: './answer-challenge.component.html',
    styleUrls: ['./answer-challenge.component.scss'],
    imports: [
        NgOptimizedImage,
        FormsModule,
        FlexModule,
        MatFormField,
        NgClass,
        ExtendedModule,
        MatInput,
        ReactiveFormsModule,
        NgxIntlTelInputModule,
        MatProgressSpinner,
        MatIcon,
        AsyncPipe,
    ],
})
export class AnswerChallengeComponent implements OnInit, OnDestroy, AfterContentInit {
  countDown: Subscription;
  counter = 60;
  tick = 1000;

  digit1 = new UntypedFormControl('', [Validators.required]);
  digit2 = new UntypedFormControl('', [Validators.required]);
  digit3 = new UntypedFormControl('', [Validators.required]);
  digit4 = new UntypedFormControl('', [Validators.required]);
  digit5 = new UntypedFormControl('', [Validators.required]);
  digit6 = new UntypedFormControl('', [Validators.required]);
  @ViewChild('digit1el', { static: true }) digit1element: ElementRef;
  @ViewChild('digit2el', { static: true }) digit2element: ElementRef;
  @ViewChild('digit3el', { static: true }) digit3element: ElementRef;
  @ViewChild('digit4el', { static: true }) digit4element: ElementRef;
  @ViewChild('digit5el', { static: true }) digit5element: ElementRef;
  @ViewChild('digit6el', { static: true }) digit6element: ElementRef;

  private errorMessage_ = new BehaviorSubject('');
  public errorMessage = this.errorMessage_.asObservable();

  private busy_ = new BehaviorSubject(false);
  public busy = this.busy_.asObservable();

  private allSubscriptions = new Subscription();

  private sms_ = new BehaviorSubject('');
  public sms = this.sms_.asObservable();

  signInNumber: string = null;
  trialWebsite: string = null;

  currentRoute: string = null;

  constructor(private auth: AuthService, private toastr: ToastrService, private router: Router, private dataService: DataShareService, private location: Location, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.allSubscriptions.add(
      this.router.events.pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(event => {
          console.log(event)
          this.currentRoute = (event as NavigationEnd).url;
          console.log("current route is :", this.currentRoute);
          this.dataService.setLastRoute('/enter-secret-code');
        })
    );

    this.allSubscriptions.add(
      this.route.queryParamMap.subscribe(params => {
        console.log("Inside answer challenge component. Query params are :", params);
        if (params.get('number'))
          this.signInNumber = params.get('number');
        if (params.get('website'))
          this.trialWebsite = params.get('website');
      })
    );

    this.countDown = timer(0, this.tick).subscribe(() => {
      if (this.counter > 0)
        --this.counter
      else
        this.counter = 0
    });
    // Get e-mail address the code was sent to
    // It is a public challenge parameter so let's try it that way
    this.auth.getPublicChallengeParameters()
      .then(param => this.sms_.next(param.sms))
      .catch(e => {
        console.log('Error Fetching Public Challenge Parameter', e);
      });;

    // Move focus to next field upon entry of a digit
    [2, 3, 4, 5, 6].forEach(digit => {
      const prev = this[`digit${digit - 1}`] as UntypedFormControl;
      const next = this[`digit${digit}element`] as ElementRef;
      this.allSubscriptions.add(prev.valueChanges.pipe(
        tap(() => {
          if (prev.value) {
            setTimeout(() => {
              next?.nativeElement?.focus();
              next?.nativeElement?.setSelectionRange(0, 1);
            }, 100)
            // next.nativeElement.focus();
            // next.nativeElement.setSelectionRange(0, 1);
          }
        })
      ).subscribe());
    });

    // If the user copy pastes the code into the first digit field
    // we'll be so kind to cut it in 6 pieces and distribute it to the right fields
    this.allSubscriptions.add(
      this.digit1.valueChanges.pipe(
        tap(value => {
          if (value && value.length > 1) {
            const digits = value.split('').slice(0, 6);
            this.digit1.setValue(digits[0]);
            this.digit2.setValue(digits[1]);
            this.digit3.setValue(digits[2]);
            this.digit4.setValue(digits[3]);
            this.digit5.setValue(digits[4]);
            this.digit6.setValue(digits[5]);
          }
        })
      ).subscribe()
    );
  }

  ngOnDestroy() {
    this.allSubscriptions.unsubscribe();
    if (this.countDown) {
      this.countDown.unsubscribe();
      this.countDown = null;
    }
  }

  ngAfterContentInit() {

    setTimeout(() => {
      this.digit1element?.nativeElement?.focus();
    }, 100)
    // this.digit1element.nativeElement.focus();
  }

  onKeydown(event){
    event.preventDefault();
  }

  public async submit() {
    if(this.digit1.valid && this.digit2.valid && this.digit3.valid && this.digit4.valid && this.digit5.valid && this.digit6.valid){
      try {
        this.errorMessage_.next('');
        this.busy_.next(true);
        const answer = [1, 2, 3, 4, 5, 6]
          .map(digit => (this[`digit${digit}`] as UntypedFormControl).value)
          .join('');
        const loginSucceeded = await this.auth.answerCustomChallenge(answer);
        if (loginSucceeded) {
          if (this.trialWebsite) {
            this.router.navigate(['/setup-workspace'], { queryParams: { website: this.trialWebsite } });
          } else {
            this.router.navigate(['/home/dashboard']);
          }
          //Remove intermediate sign-in/sign-up data
          localforage.removeItem('lastSignInNumber');
          localforage.removeItem('lastSignUpData');
        } else {
          this.errorMessage_.next('That\'s not the right code');
          this.toastr.error("Error Occured", 'That\'s not the right code');
        }
      } catch (err) {
        this.errorMessage_.next(err.message || err);
        console.log(err);
        this.showErrorInToastr(err, 'Error Occured in Sign-In. Please try again to Sign In.');
        this.router.navigate(['/sign-in']);
      } finally {
        this.busy_.next(false);
      }
    }
  }

  showErrorInToastr(e, title) {
    if (e.errors && e.errors.length > 0) {
      for (let _i = 0; _i < e.errors.length; _i++) {
        this.toastr.error(title, e.errors[_i].message);
        console.log(e.errors[_i].message);
      }
    }
  }

  goBack(): void {
    this.location.back()
  }

  async retryOtp(): Promise<void> {
    this.busy_.next(true);
    this.errorMessage_.next('');
    try {
      await this.auth.signIn(this.signInNumber);
    } catch (err) {
      this.errorMessage_.next(err.message || err);
      console.log("Error Occured in Sign-In", err);
      this.showErrorInToastr(err, 'Error Occured in Sign-In');
    } finally {
      this.busy_.next(false);
      this.counter = 60;
    }
  }
}
